export default __webpack_public_path__ + "static/media/collegepredpopup.01fe5f72.png";